export enum HelpdeskTaskReportMethodEnum {
  BY_TIME = 'BY_TIME',
  FINISH_DATE = 'FINISH_DATE',
  START_DATE = 'START_DATE',
  DEADLINE_DATE = 'DEADLINE_DATE',
}
